




















































































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Devis} from '@/models';

import storeDevis from '@/stores/modules/devis';

import InputPhone from '@/components/Input/Phone.vue';
import InputCountry from "@/components/Input/Country.vue";
import InputZipCode from "@/components/Input/ZipCode.vue";

import storeClient from "@/stores/modules/client"
import InputDatePicker from "@/components/Input/DatePicker.vue";

@Component({
	components: {
		InputPhone,
		InputCountry,
		InputZipCode,
		InputDatePicker,
	}
})
export default class CrudDevisEdit extends AbstractEditVue<Devis> {

	private step: number = 1;
	private storeDevis = storeDevis;
	private storeClient = storeClient;

	public constructor() {
		super(
			storeDevis,
			'Element modifié',
			'Element créé',
		);
	}

	protected async onSubmit(): Promise<void> {
		this.item.status = 'brouillon';
		super.onSubmit();
		this.step = 1;
	}

	public async mounted(): Promise<void> {
		await storeDevis.dispatch('getAll');
		await storeClient.dispatch('getAll');
		await super.mounted();
	}

	public async refresh(): Promise<void> {
		await super.refresh();
		if (this.$route.name === 'devis-edit') {
			this.$route.meta.title = 'Modification  d\'un élément';
		}
	}

}
